var React = require('react');

function MenuBurgerInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"8.94844","y1":"18.7","x2":"25.0484","y2":"18.7","stroke":"current","strokeWidth":"2.6","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"1.3","y1":"10.2","x2":"25.05","y2":"10.2","stroke":"current","strokeWidth":"2.6","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"8.94844","y1":"1.7","x2":"25.0484","y2":"1.7","stroke":"current","strokeWidth":"2.6","strokeLinecap":"round","key":2})]);
}

MenuBurgerInline.defaultProps = {"width":"27","height":"20","viewBox":"0 0 27 20","fill":"none"};

module.exports = MenuBurgerInline;

MenuBurgerInline.default = MenuBurgerInline;
